import { render, staticRenderFns } from "./DepositChannel.vue?vue&type=template&id=e1f248e8&scoped=true"
import script from "./DepositChannel.vue?vue&type=script&lang=js"
export * from "./DepositChannel.vue?vue&type=script&lang=js"
import style0 from "./DepositChannel.vue?vue&type=style&index=0&id=e1f248e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1f248e8",
  null
  
)

export default component.exports